module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list pending-interview-page"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', [_vm._v("外教招聘")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("待面试老师")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "page-head"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "page-actions"
  }, [_c('Button', {
    attrs: {
      "type": _vm.view === 'list' ? 'primary' : 'ghost',
      "icon": "android-list"
    },
    on: {
      "click": function($event) {
        return _vm.switchView('list')
      }
    }
  }, [_vm._v("列表视图")]), _vm._v(" "), _c('span', {
    staticClass: "pill is-blue"
  }, [_vm._v("今日面试 (" + _vm._s(_vm.summary.todayInterview || 0) + ")")]), _vm._v(" "), _c('span', {
    staticClass: "pill is-green"
  }, [_vm._v("今日试讲 (" + _vm._s(_vm.summary.todayDemo || 0) + ")")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": _vm.view === 'schedule' ? 'primary' : 'ghost',
      "icon": "calendar"
    },
    on: {
      "click": function($event) {
        return _vm.switchView('schedule')
      }
    }
  }, [_vm._v("面试时间表")])], 1)]), _vm._v(" "), (_vm.view === 'list') ? [_c('div', {
    staticClass: "search",
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.search.apply(null, arguments)
      }
    }
  }, [_c('Form', {
    attrs: {
      "label-width": 80,
      "show-message": false,
      "label-position": "right"
    }
  }, [_c('Row', {
    attrs: {
      "type": "flex",
      "gutter": 16
    }
  }, [_c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "ID/姓名"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "老师ID / 姓名 / 邮箱"
    },
    model: {
      value: (_vm.queryParam.keyword),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "keyword", $$v)
      },
      expression: "queryParam.keyword"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "国籍"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "国籍"
    },
    model: {
      value: (_vm.queryParam.nationality),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "nationality", $$v)
      },
      expression: "queryParam.nationality"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "渠道"
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "全部",
      "clearable": ""
    },
    model: {
      value: (_vm.queryParam.regFrom),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "regFrom", $$v)
      },
      expression: "queryParam.regFrom"
    }
  }, _vm._l((_vm.channelOptions), function(item) {
    return _c('Option', {
      key: item.id,
      attrs: {
        "value": item.param
      }
    }, [_vm._v(_vm._s(item.status === 0 ? (item.name + '（停用）') : item.name))])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "推荐人"
    }
  }, [_c('div', {
    staticClass: "referrer-field"
  }, [_c('Input', {
    attrs: {
      "disabled": _vm.noReferrer,
      "placeholder": "推荐人姓名"
    },
    model: {
      value: (_vm.referrerName),
      callback: function($$v) {
        _vm.referrerName = $$v
      },
      expression: "referrerName"
    }
  }), _vm._v(" "), _c('Checkbox', {
    model: {
      value: (_vm.noReferrer),
      callback: function($$v) {
        _vm.noReferrer = $$v
      },
      expression: "noReferrer"
    }
  }, [_vm._v("无推荐人")])], 1)])], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "HR"
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "全部",
      "clearable": "",
      "transfer": ""
    },
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (_vm.queryParam.hr),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "hr", $$v)
      },
      expression: "queryParam.hr"
    }
  }, _vm._l((_vm.$constant.hrList), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "面试状态"
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "全部",
      "clearable": ""
    },
    model: {
      value: (_vm.queryParam.interviewStatus),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "interviewStatus", $$v)
      },
      expression: "queryParam.interviewStatus"
    }
  }, _vm._l((_vm.stageStatus), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "试讲状态"
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "全部",
      "clearable": ""
    },
    model: {
      value: (_vm.queryParam.demoStatus),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "demoStatus", $$v)
      },
      expression: "queryParam.demoStatus"
    }
  }, _vm._l((_vm.stageStatus), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "复审"
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "全部",
      "clearable": ""
    },
    model: {
      value: (_vm.queryParam.reviewStatus),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "reviewStatus", $$v)
      },
      expression: "queryParam.reviewStatus"
    }
  }, _vm._l((_vm.reviewStatus), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "Offer状态"
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "全部",
      "clearable": ""
    },
    model: {
      value: (_vm.queryParam.offerStatus),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "offerStatus", $$v)
      },
      expression: "queryParam.offerStatus"
    }
  }, _vm._l((_vm.offerStatus), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "面试时间"
    }
  }, [_c('DatePicker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "value": _vm.interviewRange,
      "type": "daterange",
      "format": "yyyy-MM-dd",
      "clearable": "",
      "placeholder": "选择日期区间",
      "transfer": ""
    },
    on: {
      "on-change": _vm.onInterviewRangeChange
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "试讲时间"
    }
  }, [_c('DatePicker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "value": _vm.demoRange,
      "type": "daterange",
      "format": "yyyy-MM-dd",
      "clearable": "",
      "placeholder": "选择日期区间",
      "transfer": ""
    },
    on: {
      "on-change": _vm.onDemoRangeChange
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label-width": 20
    }
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "icon": "search",
      "loading": _vm.loading
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("搜索")]), _vm._v(" "), _c('Button', {
    staticStyle: {
      "margin-left": "8px"
    },
    on: {
      "click": _vm.reset
    }
  }, [_vm._v("重置")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "batch-bar"
  }, [_c('span', {
    staticClass: "batch-hint"
  }, [_vm._v("已选 " + _vm._s(_vm.selectedRows.length) + " 人（当前页）")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "disabled": !_vm.selectedRows.length || _vm.batchLoading,
      "loading": _vm.batchLoading === 'review'
    },
    on: {
      "click": _vm.batchSubmitReview
    }
  }, [_vm._v("批量提交复审")]), _vm._v(" "), _c('Button', {
    attrs: {
      "disabled": !_vm.selectedRows.length || _vm.batchLoading,
      "loading": _vm.batchLoading === 'reserve'
    },
    on: {
      "click": _vm.openBatchReserve
    }
  }, [_vm._v("批量转储备")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "success",
      "disabled": !_vm.selectedRows.length || _vm.batchLoading,
      "loading": _vm.batchLoading === 'offer'
    },
    on: {
      "click": _vm.batchOfferSent
    }
  }, [_vm._v("批量发Offer")])], 1), _vm._v(" "), _c('Table', {
    attrs: {
      "border": "",
      "columns": _vm.columns,
      "data": _vm.tableData,
      "loading": _vm.loading,
      "size": "small"
    },
    on: {
      "on-selection-change": _vm.onSelectionChange
    }
  }), _vm._v(" "), _c('Page', {
    staticClass: "page",
    attrs: {
      "total": _vm.totalCount,
      "current": _vm.pageIndex,
      "page-size": _vm.pageSize,
      "show-total": "",
      "show-sizer": "",
      "show-elevator": "",
      "page-size-opts": [10, 20, 50, 100],
      "placement": "top"
    },
    on: {
      "on-change": _vm.onPageChange,
      "on-page-size-change": _vm.onPageSizeChange
    }
  })] : _c('recruit-schedule-board', {
    ref: "board",
    on: {
      "open-tch": function (row) { return _vm.openTchInfoModal(row.tchId); },
      "on-change": function($event) {
        return _vm.afterChange(false)
      }
    }
  }), _vm._v(" "), _c('recruit-schedule-modal', {
    attrs: {
      "row": _vm.activeRow,
      "kind": _vm.scheduleKind
    },
    on: {
      "on-success": function($event) {
        return _vm.afterChange(true)
      }
    },
    model: {
      value: (_vm.scheduleVisible),
      callback: function($$v) {
        _vm.scheduleVisible = $$v
      },
      expression: "scheduleVisible"
    }
  }), _vm._v(" "), _c('recruit-notes-modal', {
    attrs: {
      "row": _vm.activeRow
    },
    on: {
      "on-success": function($event) {
        return _vm.afterChange(true)
      }
    },
    model: {
      value: (_vm.notesVisible),
      callback: function($$v) {
        _vm.notesVisible = $$v
      },
      expression: "notesVisible"
    }
  }), _vm._v(" "), _c('recruit-review-modal', {
    attrs: {
      "row": _vm.activeRow,
      "mode": _vm.reviewMode
    },
    on: {
      "on-success": function($event) {
        return _vm.afterChange(true)
      }
    },
    model: {
      value: (_vm.reviewVisible),
      callback: function($$v) {
        _vm.reviewVisible = $$v
      },
      expression: "reviewVisible"
    }
  }), _vm._v(" "), _c('recruit-reason-modal', {
    attrs: {
      "title": _vm.reason.title,
      "label": _vm.reason.label,
      "desc": _vm.reason.desc,
      "placeholder": _vm.reason.placeholder,
      "init-reason": _vm.reason.init,
      "loading": _vm.reasonLoading,
      "kind-options": _vm.reason.kindOptions,
      "kind-label": _vm.reason.kindLabel,
      "init-kind": _vm.reason.initKind
    },
    on: {
      "on-ok": _vm.onReasonOk
    },
    model: {
      value: (_vm.reasonVisible),
      callback: function($$v) {
        _vm.reasonVisible = $$v
      },
      expression: "reasonVisible"
    }
  }), _vm._v(" "), _c('tch-info-modal', {
    attrs: {
      "value": _vm.showTchInfoModal,
      "tchId": _vm.tchId,
      "showTchSelf": true,
      "successCallback": _vm.reloadPage,
      "recruit-flow-entry": "待面试老师"
    },
    on: {
      "on-close": function($event) {
        _vm.showTchInfoModal = false
      }
    }
  }), _vm._v(" "), _c('tch-apply-form-modal', {
    attrs: {
      "visible": _vm.showApplyModal,
      "tchId": _vm.applyTchId
    },
    on: {
      "on-close": function($event) {
        _vm.showApplyModal = false
      }
    }
  })], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h2', {
    staticClass: "page-title"
  }, [_vm._v("待面试老师")]), _vm._v(" "), _c('p', {
    staticClass: "page-sub"
  }, [_vm._v("管理面试和试讲课安排，评估外教教学能力 · Manage interview & demo")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-65eec272","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/teacher/recruit/TchPendingInterview.vue
// module id = 1860
// module chunks = 8